var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5EA2FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4994 2L12.6744 2.06532L17.0658 3.70522C17.6262 3.9145 17.9992 4.44888 17.9992 5.04772V16.1231C17.9992 16.9168 17.3536 17.5566 16.5617 17.5566C16.3896 17.5566 16.2189 17.5258 16.0576 17.4656L12.4994 16.1369L7.67464 17.9386L7.49972 18.0039L7.3248 17.9386L3.54166 16.5258C2.61536 16.1799 2 15.2972 2 14.3093V3.88081C2 3.08712 2.64554 2.44728 3.43745 2.44728C3.60955 2.44728 3.78029 2.4781 3.94152 2.53831L7.49972 3.86706L12.3245 2.06532L12.4994 2ZM11.9283 3.28072L7.85716 4.80103V16.803L11.9283 15.2827V3.28072ZM12.9997 3.25427V15.2562L16.4075 16.5288C16.4567 16.5472 16.509 16.5566 16.5617 16.5566C16.8053 16.5566 16.9992 16.3606 16.9992 16.1231V5.04772C16.9992 4.86829 16.8873 4.70603 16.7159 4.64204L12.9997 3.25427ZM3.59169 3.47512L6.78579 4.66791V16.6699L3.89149 15.589C3.35423 15.3884 3 14.8778 3 14.3093V3.88081C3 3.64335 3.19388 3.44728 3.43745 3.44728C3.49016 3.44728 3.54242 3.45672 3.59169 3.47512ZM7.49972 16.9365L7.40414 16.9008H7.59529L7.49972 16.9365Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d5a3fdd00d935ab8b8c3b415ac641e38.svg";
export { ForwardRef as ReactComponent };